import React, { Component } from 'react'

class RoomDisplay extends Component {

    render(){
        const {
            room,
            errorMessages,
            disabled,
            onNameChange,
            onCapacityChange,
            onAvailableChange
        } = this.props
        return(
            <div className="guest-reservation-block">
                <div className="personal-data-block">
                    <table>
                        <tr>
                            <th className="table-left">Nombre</th>
                            <th className={errorMessages.invalidName ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <input
                                    type="text"
                                    className="text-input"
                                    value={room.name}
                                    disabled={disabled}
                                    onChange={onNameChange}
                                />
                            </div>
                            </th>
                        </tr>
                        <tr>
                            <th className="table-left">Capacidad</th>
                            <th className={errorMessages.invalidCapacity ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <input
                                    type="text"
                                    className="text-input"
                                    value={room.capacity}
                                    disabled={disabled}
                                    onChange={onCapacityChange}
                                />
                            </div>
                            </th>
                        </tr>
                    </table>
                </div>
                <div className="wheel-chair-block">
                    <input
                        type="checkbox"
                        id="available"
                        name="available"
                        value="available"
                        onChange={onAvailableChange}
                        checked={room.available}
                        disabled={disabled}
                    />
                        <label for="available">Disponible para reservar </label>
                </div>
            </div>
        )
    }

}
export default RoomDisplay
